module.exports = __webpack_public_path__ + "img/logo.82019af3.png";